/**
 * Klasa zawiera metody służące operacjom na datach
 *
 */


class ColumnsAdapter {
  public addSorter = <Column extends SingleColumn>(columns: Column[]): Column[] => columns.map(
    col => col.sorter ? ({
      ...col,
      sorter: (a: SingleObjectDataStructure, b: SingleObjectDataStructure) => {
        const valueA = a[col.dataIndex] ? a[col.dataIndex].toString() : '';
        const valueB = b[col.dataIndex] ? b[col.dataIndex].toString() : '';
        return valueA.localeCompare(valueB);
      },
      sortDirections: ['ascend', 'descend'],
    }) : col
  );
  /*
    Funkcja usuwająca możliwość sortowania danych w tabeli Ant Design.
  */
  public removeSorter = <Column extends SingleColumn>(columns: Column[]): Column[] => columns.map(
    col => (
      { ...col, sorter: false }
    )
  );
  public generateNonBreakColumns = <Column extends SingleColumn>(columns: Column[]): Column[] =>
    columns.map(col =>
      ({ ...col, wordWrap: 'break-word', wordBreak: 'break-word' })
    );
  /*
    Funkcja usuwająca kolumny, które nie powinny się znaleźć na liście kolumn do wyboru w panelu wyboru kolumn do wyświetlenia w tabeli.
    Używana w sytuacji, gdy na widoku nie chcemy, aby użytkownik miał możliwość schowania kolumny, bo np. jest zamockowana na stałe.
    Argumenty:
    - kolumny - standardowa konfiguracja kolumn dla widoku
    - lista kolumn, które chcemy ukryć - w formie tablicy dataIndex'ów.
  */
  public removeUnwantedColumns = <Column extends SingleColumn>(columns: Column[], unwantedColumns: string[]): Column[] => {
    return columns.filter(column => !unwantedColumns.includes(column.dataIndex));
  }
}

export default new ColumnsAdapter();